// Calen AI webchat widget — single source of truth for all ktt10.setup() calls
export const CALEN_SCRIPT_SRC = "https://app.calen.ai/webchat/plugin.js?v=6";

export const CALEN_CHAT_CONFIG = {
  id: process.env.REACT_APP_CALE_ID || "a4fveSMQZwYy6SV",
  accountId: process.env.REACT_APP_ACCOUNT_ID || "2874975",
  color: "#FFFFFF",
  showPersona: true,
  icon: "https://storage.googleapis.com/calen_public_bucket/AI%20chat%20icon-02.png",
};
